<template>
  <div class="background-display">
  <v-container class="px-1">
    <Navbar />
    <v-container>
      <v-card>
        <v-toolbar dark color="#00b2bb">
          <p class="my-5 font-weight-thin title-size">{{ titulo }}</p>
          <v-spacer></v-spacer>
          <v-btn v-if="documento.urlDocumento" color="white" rounded class="mr-2 primary--text hidden-xs-only" @click="downloadFile(documento.urlDocumento)">Descargar</v-btn>
          <form v-if="documento.webPay" :action="documento.webPay.url" method="POST" class="hidden-xs-only">
            <input type="hidden" name="token_ws" :value="documento.webPay.token">
            <v-btn type="submit" color="white" rounded @click="overlay = !overlay" class="mr-5 primary--text">Pagar</v-btn>
          </form>
        </v-toolbar>
        <v-card-text class="px-1">
          <v-alert v-model="alertAxios" border="left" close-text="Close Alert" dismissible dense outlined type="error">
              Ha ocurrido un error!
          </v-alert>
          <v-alert v-if="$route.query.fail" border="left" close-text="Close Alert" dismissible dense outlined type="error">
            Transacción Fallida. Por favor intente de nuevo.
          </v-alert>
            <v-row>
              <v-col xs="6" md="4" sm="6" lg="4" v-if="documento.ordenCompra">
                <h4 class="font-weight-regular black--text ml-5">Orden de Compra</h4>
                <v-text-field flat
                  solo
                  class="ml-2"
                  style="width: 80%;"
                  disabled
                  v-model= documento.ordenCompra
                ></v-text-field>
              </v-col>
              <v-spacer v-if="!documento.ordenCompra"></v-spacer>
              <v-col xs="6" md="4" sm="6"
              offset-md="4" lg="4" class="px-2">
                <h4 class="font-weight-regular black--text ml-3">Fecha</h4>
                <v-text-field flat
                  :value = "displayValue(documento.fecha)"
                  style="width: 80%;"
                  solo
                  disabled
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" xs="12" sm="12" md="12">
                <h4 class="font-weight-regular black--text ml-5">Trámite</h4>
                <h3 class="font-weight-regular ml-5 mt-3" disabled v-text="documento.nombreTramite"></h3>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="12" xs="12" sm="6" md="6">
                <h4 class="font-weight-regular black--text mx-5">Estado</h4>
              <v-text-field flat
                  solo
                  disabled
                  class="mx-2"
                  v-model= documento.estadoTramite
                ></v-text-field>
              </v-col>
            </v-row>
              <v-simple-table class="mb-8 mx-5">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left  black--text">Nombre:</th>
                      <th class="text-left  black--text">Correo:</th>
                      <th class="text-left  black--text">RUT/Pasaporte</th>
                      <th class="text-left  black--text" v-if="!documento.urlDocumento">Estado</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="firmo in documento.firmantes" :key="firmo.nombre">
                      <td>{{ firmo.nombre }}</td>
                      <td>{{ firmo.correo }}</td>
                      <td>{{ firmo.rut }}</td>
                      <td v-if="!documento.urlDocumento">Por Firmar</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            <v-row>
              <v-spacer></v-spacer>
              <v-col cols="12" xs="12" sm="4" md="3" lg="3">
                <h4 class="font-weight-regular black--text ml-5">Costo LegalSign (Firma Electronica)</h4>
                <v-text-field flat
                  label="TOC"
                  solo
                  class="ml-2"
                  style="width: 70%;"
                  prepend-inner-icon="mdi-currency-usd"
                  disabled
                  v-model= documento.precioToc
                  ></v-text-field>
                <h4 class="font-weight-regular black--text ml-5">Costo Notaria</h4>
                <v-text-field flat
                  label="Notaria"
                  solo
                  class="ml-2"
                  style="width: 70%;"
                  prepend-inner-icon="mdi-currency-usd"
                  disabled
                  v-model= documento.precioTramite
                  ></v-text-field>
                <h4 class="font-weight-regular black--text ml-5">Costo Total</h4>
                <v-text-field flat
                  label="Total"
                  solo
                  class="ml-2"
                  style="width: 70%;"
                  prepend-inner-icon="mdi-currency-usd"
                  disabled
                  v-model= documento.precioTotal
                  ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <template>
              <v-row cols="12" xs="6" md="4" lg="4" class="mx-2">
                <template >
                  <v-btn color="normal" :to="'/mydocument/documentlist'" class="ml-5" style="margin-top: 40px;"
                  >Volver</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn v-if="documento.urlDocumento" color="#00b2bb" dark class="mr-5 hidden-sm-and-up" style="margin-top: 40px;" @click="downloadFile(documento.urlDocumento)">Descargar</v-btn>
                  <form v-if="documento.webPay" :action="documento.webPay.url" method="POST" class="hidden-sm-and-up">
                    <input type="hidden" name="token_ws" :value="documento.webPay.token">
                    <v-btn type="submit" color="#00b2bb" @click="overlay = !overlay" dark class="mr-5" style="margin-top: 40px;">Pagar</v-btn>
                  </form>
                </template>
              </v-row>
              </template>
            </v-row>
        </v-card-text>
        <v-overlay :value="overlay">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
      </v-card>
      </v-container>
    </v-container>
  </div>
</template>
<style>
.title-size {
  font-size: 1.25em;
}
.background-display {
  background-color: dodgerblue;
  width: auto;
  min-height: 100%;
}
.complete-text {
  word-break: break-all;
}
</style>
<script>
// @ is an alias to /src
import Navbar from '@/components/Navbar.vue'
import api from '@/plugins/api'
import moment from '@/plugins/moment'
import axios from 'axios'
/* import cost1 from '@/mock/cost1.json' */

export default {
  name: 'StatusDocument',
  components: {
    Navbar
  },
  data () {
    return {
      titulo: 'Estado de Trámite',
      dialog: false,
      overlay: false,
      alertAxios: false,
      id: this.$route.params.id,
      documento: []
    }
  },
  mounted () {
    this.getTodos(this.$route.params.id)
    this.overlay = !this.overlay
  },
  /* watch: {
    overlay (val) {
      val && setTimeout(() => {
        this.overlay = false
      }, 5500)
    }
  }, */
  methods: {
    async getTodos (id) {
      try {
        const response = await api.get(`mis-tramites/${id}`)
        this.documento = response.data
        this.overlay = false
        /* console.log(this.documento) */
      } catch (error) {
        this.alertAxios = true
        this.overlay = false
        console.log('Get error ' + error)
      }
    },
    displayValue (value) {
      return value ? moment(value).format('DD-MM-YYYY') : ''
    },
    forceFileDownload (response) {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      /* console.log('aca ' + link.href) */
      link.setAttribute('download', 'Tramite.pdf') // or any other extension
      document.body.appendChild(link)
      link.click()
    },
    downloadFile (urlDocumento) {
      axios({
        method: 'get',
        url: urlDocumento,
        responseType: 'arraybuffer'
      })
        .then(response => {
          this.forceFileDownload(response)
        })
        .catch(() => console.log('Error al descargar archivo'))
    }
  }
}
</script>
